export const FETCH_PRODUCTRETURNDETAILS_INIT_ACTION =
  "FETCH_PRODUCTRETURNDETAILS_INIT_ACTION";
export const FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION =
  FETCH_PRODUCTRETURNDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_PRODUCTRETURNDETAILS_FAIL_ACTION =
  FETCH_PRODUCTRETURNDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_PRODUCTRETURNVIEW_INIT_ACTION =
  "FETCH_PRODUCTRETURNVIEW_INIT_ACTION";
export const FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION =
  FETCH_PRODUCTRETURNVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_PRODUCTRETURNVIEW_FAIL_ACTION =
  FETCH_PRODUCTRETURNVIEW_INIT_ACTION + "_ERROR";

export const ADD_CREDITNOTES_INIT_ACTION = "ADD_CREDITNOTES_INIT_ACTION";
export const ADD_CREDITNOTES_SUCCESS_ACTION =
  ADD_CREDITNOTES_INIT_ACTION + "_SUCCESS";
export const ADD_CREDITNOTES_FAIL_ACTION =
  ADD_CREDITNOTES_INIT_ACTION + "_ERROR";

export const FETCH_RETUNREJECTED_INIT_ACTION =
  "FETCH_RETUNREJECTED_INIT_ACTION";
export const FETCH_RETUNREJECTED_SUCCESS_ACTION =
  FETCH_RETUNREJECTED_INIT_ACTION + "_SUCCESS";
export const FETCH_RETUNREJECTED_FAIL_ACTION =
  FETCH_RETUNREJECTED_INIT_ACTION + "_ERROR";

export const FETCH_RETUNACCEPTED_INIT_ACTION =
  "FETCH_RETUNACCEPTED_INIT_ACTION";
export const FETCH_RETUNACCEPTED_SUCCESS_ACTION =
  FETCH_RETUNACCEPTED_INIT_ACTION + "_SUCCESS";
export const FETCH_RETUNACCEPTED_FAIL_ACTION =
  FETCH_RETUNACCEPTED_INIT_ACTION + "_ERROR";

export const PDF_RETURN_REPORT_INIT_ACTION = "PDF_RETURN_REPORT_INIT_ACTION";
export const PDF_RETURN_REPORT_SUCCESS_ACTION =
  PDF_RETURN_REPORT_INIT_ACTION + "_SUCCESS";
export const PDF_RETURN_REPORT_FAIL_ACTION =
  PDF_RETURN_REPORT_INIT_ACTION + "_ERROR";

export const FETCH_ORDERDETAIL_ACCEPT_INIT = "FETCH_ORDERDETAIL_ACCEPT_INIT";
export const FETCH_ORDERDETAIL_REJECT_INIT = "FETCH_ORDERDETAIL_REJECT_INIT";

export const UPDATE_APPROVED_QTY_INIT = "UPDATE_APPROVED_QTY_INIT";
export const UPDATE_APPROVED_QTY_SUCCESS = "UPDATE_APPROVED_QTY_SUCCESS";
export const UPDATE_APPROVED_QTY_FAIL = "UPDATE_APPROVED_QTY_FAIL";

export const UPDATE_PURCHASEORDER_TOTALS_INIT =
  "UPDATE_PURCHASEORDER_TOTALS_INIT";
export const UPDATE_PURCHASEORDER_TOTALS_SUCCESS =
  "UPDATE_PURCHASEORDER_TOTALS_SUCCESS";
export const UPDATE_PURCHASEORDER_TOTALS_FAIL =
  "UPDATE_PURCHASEORDER_TOTALS_FAIL";

export function fetchPurchaseReturns(value) {
  return {
    type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
    value: value,
  };
}
export function pageSelected(value) {
  return {
    type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
    value: value,
  };
}
export function ProductReturnview(value) {
  return {
    type: FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
    value: value,
  };
}

export function itempageSelected(value) {
  return {
    type: FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
    value: value,
  };
}
export function CreditNotesAdd(value) {
  return {
    type: ADD_CREDITNOTES_INIT_ACTION,
    value: value,
  };
}
export function returnrejected(value) {
  return {
    type: FETCH_RETUNREJECTED_INIT_ACTION,
    value: value,
  };
}
export function returnaccept(value) {
  // console.log("returnaccept++++++++++++++++++++++", value);
  return {
    type: FETCH_RETUNACCEPTED_INIT_ACTION,
    value: value,
  };
}
export function pdfreturnFullData(value) {
  return {
    type: PDF_RETURN_REPORT_INIT_ACTION,
    value: value,
  };
}

export function returnacceptOne(value) {
  return {
    type: FETCH_ORDERDETAIL_ACCEPT_INIT,
    value,
  };
}

export function returnrejectedOne(value) {
  return {
    type: FETCH_ORDERDETAIL_REJECT_INIT,
    value,
  };
}

export function updateApprovedQty(value) {
  return {
    type: UPDATE_APPROVED_QTY_INIT,
    value, // { id, approvedQntty, orderStatus }
  };
}

export function updatePurchaseOrderTotals(value) {
  return {
    type: UPDATE_PURCHASEORDER_TOTALS_INIT,
    value, // { orderId, totalApprovedAmount, totalClaimAmount }
  };
}

